import { MetaData } from "./meta-data";
import { CMSCommon, cmsLocalData } from "./cms-data";
export default class GvpPlayerState {
  cmsReturned: boolean | null = false;
  duration: any = 0;
  video: string="5001039";
  metaData:any= new MetaData(cmsLocalData[this.video]?.common);
  posterImageUrl!: string;
  recommendedVideosCTAViewData: any[] = [];
  view: Viewtype = Viewtype.CTAView;
  isPageScroll: boolean = false;
  cmsDataLocal: boolean = false;
  safariAutoPlay: boolean = false;
}

export enum Viewtype {
  CTAView = "ctaview",
  PlayerView = "player",
}
